const images = document.querySelectorAll('.js-lazy-load-image');

lazyload(images);
